import React, { Fragment, useState } from "react"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import OdnSaveButton from "./OdnSaveButton"
import classes from "./OdnFooter.module.scss"
import clsx from "clsx"

const OdpdFooter = props => {
  const {
    form,
    setForm,
    order,
    setOrders,
    enableEdit,
    setEnableEdit
  } = props

  const [t, i18n] = useTranslation()

  const [sending, setSending] = useState(false)

  const handleEnableEdit = () => {
    setEnableEdit(true)

    setForm({ note: order.note })
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["row"]}>
      {enableEdit
        ?
        <Fragment>
          <Button
            disabled={sending}
            onClick={() => setEnableEdit(false)}
            color="danger"
            className={clsx(
              classes["button"],
              isLtr && classes["button-ltr"]
            )}
          >
            {t("بازگشت")}
          </Button>

          <OdnSaveButton
            form={form}
            order={order}
            setOrders={setOrders}
            sending={sending}
            setSending={setSending}
            setEnableEdit={setEnableEdit}
          />
        </Fragment>
        :
        <Button
          onClick={handleEnableEdit}
          color="warning"
        >
          {t("ویرایش")}
        </Button>}
    </div>
  )
}

export default OdpdFooter